import { Component, HostBinding, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from '../../../core/services/confirmation.service';
import { DIALOG_TOKEN } from '../../tokens';
import { fadeInOutAnimation } from '@animations/*';
import { ConfType } from '../../../../models/enums';
import { Confirmation } from '@models/*';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  animations: [fadeInOutAnimation]
})
export class ConfirmationDialogComponent implements OnInit {
  @HostBinding('@fadeInOut') fadeInOutAnimation;
  @HostBinding('class') class = 'foreground';

  dialogText = '';
  confType = ConfType;

  constructor(
    private readonly translateService: TranslateService,
    private readonly confirmationService: ConfirmationService,
    @Inject(DIALOG_TOKEN)
    public injectedData: {
      insertionRef: ViewContainerRef;
      insertionIndex: number;
      type: ConfType;
      extras?: { [k: string]: any };
    }
  ) {}

  ngOnInit() {
    this.dialogText = this.setDialogText(this.injectedData.type, this.injectedData.extras);
  }

  private setDialogText(type: ConfType, extras?: { [k: string]: any }): string {
    let mainText = '';

    switch (type) {
      case ConfType.STATUS_IN_TRANSPORT:
      case ConfType.STATUS_DELIVERED: {
        const count = extras && extras.count;
        const status = this.translateService.instant(`STATUS.${<string>type.toUpperCase()}`);

        if (count) {
          mainText = this.translateService.instant('DIALOG.CONFIRM_STATUS_CHANGE', { status, count });
        } else {
          mainText = this.translateService.instant('DIALOG.CONFIRM_STATUS_CHANGE_SINGLE', { status });
        }

        break;
      }

      case ConfType.PROTOCOL: {
        mainText = this.translateService.instant('DIALOG.CONFIRM_PROTOCOL');

        break;
      }

      case ConfType.PROTOCOL_NO_PHOTOS: {
        if (extras.reason === 'BOTH') {
          mainText = this.translateService.instant('DIALOG.CONFIRM_PROTOCOL_NO_PHOTOS');
        } else if (extras.reason === 'DAMAGE') {
          mainText = this.translateService.instant('DIALOG.CONFIRM_PROTOCOL_NO_DAMAGE_PHOTOS');
        } else {
          mainText = this.translateService.instant('DIALOG.CONFIRM_PROTOCOL_NO_CHECKUP_PHOTOS');
        }

        break;
      }

      case ConfType.PROTOCOL_SAVE_DRAFT: {
        mainText = this.translateService.instant('DIALOG.CONFIRM_PROTOCOL_SAVE_DRAFT');
        break;
      }

      case ConfType.CANCEL_SIGNATURE: {
        mainText = this.translateService.instant('DIALOG.CONFIRM_CANCEL_SIGNATURE');

        break;
      }

      case ConfType.END_SHIFT: {
        mainText = this.translateService.instant('DIALOG.CONFIRM_END_SHIFT');

        break;
      }

      case ConfType.FUEL_REFILL: {
        const count = extras && extras.count;
        mainText = this.translateService.instant('DIALOG.CONFIRM_FUEL_REFILL', { count });

        break;
      }

      case ConfType.END_STOP_TRACKING_UNFINISHED: {
        mainText = this.translateService.instant('DIALOG.END_STOP_TRACKING_UNFINISHED');

        break;
      }

      case ConfType.UNTRACKED_STOP_WARNING: {
        const warningType = extras && extras.warningType;

        if (warningType === 'UNSTARTED') {
          mainText = this.translateService.instant('DIALOG.UNTRACKED_STOP_WARNING');
        } else {
          mainText = this.translateService.instant('DIALOG.UNTRACKED_STOP_WARNING_ANOTHER');
        }

        break;
      }

      case ConfType.DELETE_PROTOCOL_DAMAGE_COMMENT: {
        mainText = this.translateService.instant('DIALOG.DELETE_PROTOCOL_DAMAGE_COMMENT');

        break;
      }
    }

    return mainText;
  }

  public confirm(): void {
    let confirmation: Confirmation<any>;

    if (this.injectedData.type === ConfType.DELETE_PROTOCOL_DAMAGE_COMMENT) {
      confirmation = { type: ConfType.ACCEPT_DELETE_PROTOCOL_DAMAGE_COMMENT, data: null };
    } else if (this.injectedData.type === ConfType.UNTRACKED_STOP_WARNING) {
      confirmation = { type: ConfType.UNTRACKED_STOP_WARNING_OK, data: this.injectedData.extras.warningType };
    } else {
      confirmation = { type: this.injectedData.type, data: null };
    }

    this.confirmationService.sendConfirmation(confirmation);
    this.injectedData.insertionRef.remove(this.injectedData.insertionIndex);
  }

  public reject(): void {
    let confirmation: Confirmation<any>;

    if (this.injectedData.type === ConfType.DELETE_PROTOCOL_DAMAGE_COMMENT) {
      confirmation = { type: ConfType.REJECT_DELETE_PROTOCOL_DAMAGE_COMMENT, data: null };
    } else if (this.injectedData.type === ConfType.UNTRACKED_STOP_WARNING) {
      confirmation = { type: ConfType.UNTRACKED_STOP_WARNING_CANCEL, data: this.injectedData.extras.warningType };
    } else {
      confirmation = { type: ConfType.CANCEL_CONFIRMATION, data: null };
    }

    this.confirmationService.sendConfirmation(confirmation);
    this.injectedData.insertionRef.remove(this.injectedData.insertionIndex);
  }
}
